import * as React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Selectors
// Selectors
import {
    selectSchemasWithEventTypeIdExist
    // @ts-ignore
} from 'services/schemas/selectors';

export interface OwnProps {
    children: React.ReactNode;
    FallbackComponent?: React.ReactNode;
}

interface StateProps {
    schemasWithEventTypeIdExist?: boolean;
}

interface DispatchProps {}

type IProps = StateProps & DispatchProps & OwnProps;

export class SchemasWithEventTypeIdExistGate extends React.PureComponent<
    IProps
> {
    render() {
        const {
            children,
            FallbackComponent,
            schemasWithEventTypeIdExist
        } = this.props;
        if (!schemasWithEventTypeIdExist) return FallbackComponent || null;
        return children;
    }
}

const mapStateToProps = createStructuredSelector<any, any>({
    schemasWithEventTypeIdExist: selectSchemasWithEventTypeIdExist
});

export default connect<StateProps, DispatchProps, OwnProps>(mapStateToProps)(
    SchemasWithEventTypeIdExistGate
);
